import { render, staticRenderFns } from "./HomeMechanism.vue?vue&type=template&id=e6da146c&scoped=true&"
import script from "./HomeMechanism.vue?vue&type=script&lang=js&"
export * from "./HomeMechanism.vue?vue&type=script&lang=js&"
import style0 from "./HomeMechanism.vue?vue&type=style&index=0&id=e6da146c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6da146c",
  null
  
)

export default component.exports